// extracted by mini-css-extract-plugin
export default {"message":"LockMessage-module__message__zod68","content":"LockMessage-module__content__aQOXY","title":"LockMessage-module__title__lOy0N","text":"LockMessage-module__text__GUdYF"};